const hero_banners = [
  {
    big_title: "Sony WH-XB910N Wireless NC XB Headphone - Black",
    small_title: "headphone",
    image: "images/headphone.avif",
    description: "lorem ",
  },
  {
    big_title:
      "Soundcore By Anker R50i True Wireless , IPX5-Water Resistant, AI",
    small_title: "headphone",
    image: "images/headphone2.avif",
    description:
      "took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuri",
  },
  {
    big_title: "Apple iPhone 15 (128 GB) - Black",
    small_title: "mobiles",
    image: "images/IPhones.avif",
    description:
      "took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuri",
  },
  {
    big_title: "mens ACTIV SPCIAL SPORT SHOES Sneaker",
    small_title: "electronics",
    image: "images/watch.jpg",
    description:
      "took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuri",
  },
  {
    big_title:
      "Nokia t10 android tablet playback, 4gb ram + 64gb rom. ocean blue",
    small_title: "electronics",
    image: "images/main-banner-1.jpg",
    description:
      "took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuri",
  },
];

export default hero_banners;
